import * as THREE from 'three'

/**
 * Low-poly simge yapılar: Galata Kulesi (tools/blender/galata.py) ve Pisa Kulesi (tools/blender/pisa.py).
 * Sabit; girişin kuzeyinde başlangıç görüntüsünü çerçeveler. Döndürülmez: Pisa'nın eğimi ve işlenmiş
 * gölgeler güneş yönüne göre modele gömülü (llp.SUN_DIRECTION).
 */
const LANDMARKS = [
    ['galata', 16, 16],
    ['pisa', - 16, 16]
]

export default class LandmarksSection
{
    constructor(_options)
    {
        this.resources = _options.resources
        this.objects = _options.objects

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.items = LANDMARKS.map(([_name, _x, _y]) => this.objects.add({
            base: this.resources.items[`${_name}StaticBase`].scene,
            collision: this.resources.items[`${_name}StaticCollision`].scene,
            floorShadowTexture: this.resources.items[`${_name}StaticFloorShadowTexture`],
            offset: new THREE.Vector3(_x, _y, 0),
            mass: 0
        }))
    }
}
